import React, { FunctionComponent, useMemo, useSyncExternalStore } from 'react'
import { createPortal } from 'react-dom'
import { reactular } from '@vendhq/reactular'
import { PrintRegisterClosure } from '../register/PrintRegisterClosure'
import { PrintPayload } from './printTypes'

export const PrintTypesHandled = ['register-closure']

let payload: PrintPayload | null = null

let listeners: Array<() => void> = []

const addListener = (listener: () => void): void => {
  listeners.push(listener)
}

const removeListener = (listener: () => void): void => {
  listeners = listeners.filter(l => l !== listener)
}

const subscribe = (listener: () => void): (() => void) => {
  addListener(listener)
  return () => removeListener(listener)
}

const getPayload = () => payload

export const setPrintPayload = (newPayload: PrintPayload | null): void => {
  payload = newPayload
  listeners.forEach(listener => listener())
}

export const PrintContainer: FunctionComponent = () => {
  const payload = useSyncExternalStore<PrintPayload | null>(
    subscribe,
    getPayload
  )

  const printComponent = useMemo(() => {
    switch (payload?.type) {
      case 'register-closure':
        return <PrintRegisterClosure data={payload.data} />
      default:
        return null
    }
  }, [payload])

  return createPortal(
    <div className="vd-show-print">{printComponent}</div>,
    document.body
  )
}

export const ReactPrintContainerComponent = reactular(
  PrintContainer,
  [],
  'reactWrapper'
)
